import { EModuleConfigType } from './enum-type';

export function isNumericType(type: string): boolean {
  return [EModuleConfigType.Number, EModuleConfigType.Int, EModuleConfigType.Integer].includes(type as EModuleConfigType);
}

export function isUnknownType(type: string): boolean {
  return !Object.values(EModuleConfigType).includes(type as EModuleConfigType);
}
